import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentoInteresControllerService, DocumentoInteresModel } from 'api-rest';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';

@Component({
  selector: 'lib-category-terms-dialog',
  templateUrl: './category-terms-dialog.component.html',
})
export class CategoryTermsDialogComponent implements OnInit, OnDestroy {
  fileUrl?: SafeResourceUrl;
  private objectUrl?: string;
  private nombreDocumento?: string;
  // El visor PDF nativo no expone su scroll: se exige hacer scroll en el modal hasta el final
  scrolledToEnd = false;
  documentoLeido = false;

  constructor(
    private dialogRef: MatDialogRef<CategoryTermsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { categoriaId: number },
    private documentoInteresService: DocumentoInteresControllerService,
    private sanitizer: DomSanitizer,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService
  ) {}

  ngOnInit(): void {
    this.cargarDocumento();
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  cargarDocumento(): void {
    this.documentoInteresService.findByIdentificador('ContratoCatSinGobernanza').subscribe({
      next: (response: DocumentoInteresModel) => {
        this.nombreDocumento = response?.nombre;
        const binary = atob(response?.documento ?? '');
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        this.objectUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        this.spinnerSrv.loadingHide();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el documento.', 'error');
      },
    });
  }

  onScroll(event: Event): void {
    const el = event.target as HTMLElement;
    // Margen de 5px por redondeos de scroll
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      this.scrolledToEnd = true;
    }
  }

  aceptar(): void {
    this.dialogRef.close(this.nombreDocumento ?? '');
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }
}
